module.exports = __webpack_public_path__ + "img/ma245.46fb6987.png";